<template>
  <div class="container-fluid px-md-4">
    <div class="panel-heading my-2">
      <h2 class="text-left">Tenant Management</h2>
    </div>
    <form class="needs-validation px-2 pt-2" @submit.prevent="getTenants">
     <div class="form-group row mx-0 justify-content-end" :style="{ marginBottom: '1rem' }">
          <div class=" my-2 ">
          <button
              title="Add new"
              class="k-button k-secondary"
              @click="insert"
              type="button"
            >
              <i class="fa fa-plus mr-2" aria-hidden="true"></i>

              Add new
          </button>
          </div>
      </div>
    </form>
    <div class="example-wrapper" v-if="tenants">
      <Grid
        ref="grid"
        :style="{ height: '55vh' }"
        :pageable="true"
        :skip= "skip"
        :data-items="result"
        :columns="columns"
        :take="take"
        :total="total"
        @pagechange="pageChangeHandler"
      >
        <template v-slot:myTemplate="{ props }">
          <custom :data-item="props.dataItem" @edit="edit" @remove="remove" />
        </template>

        <grid-norecords> There is no data available custom </grid-norecords>
      </Grid>
      <dialog-container
        v-if="tenantInEdit"
        :dialog-title="dialogTitle"
        :data-item="tenantInEdit"
        :layouts="layouts"
        @save="save"
        @cancel="cancel"
      >
      </dialog-container>
    </div>
  </div>
</template>
<script>
import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
import { sampleroleClaims } from "./data";
import DialogContainer from "./DialogContainer";
import CommandCell from "./CommandCell";
import axios from "axios";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { oidcSettings } from "../../services/store";
export default {
  components: {
    Grid: Grid,
    "grid-toolbar": GridToolbar,
    "grid-norecords": GridNoRecords,
    "dialog-container": DialogContainer,
    custom: CommandCell,
    dropdownlist: DropDownList,
  },
  props: {
    identity: {
      type: Object,
      default: null,
    }
  },
  data: function () {
    return {
      base_url: undefined,
      sort: [{ field: "id", dir: "asc" }],
      tenants: undefined, //sampleroleClaims,
      selectedIdentity: this.identity,
      bgPath: undefined,
      logoPath: undefined,
      source: [],
      layouts: [],
      events: [],     
      skip: 0,
      take: 10,
      tenantInEdit: undefined,
      columns: [
        {
          field: "name",
          editable: false,
          title: "Tenant Name",
        },
        { cell: "myTemplate", width: "150px" },
      ],
    };
  },
  mounted: function () {
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";
    if(this.selectedIdentity!=null)
    {
      this.getTenants();
      this.getLoginLayouts();
    }
  },
  watch:{
    identity:function(){
      this.selectedIdentity=this.identity;
      this.getTenants();
    }
  },
  computed: {
    dialogTitle() {
      return `${this.tenantInEdit.id === undefined ? "Add" : "Edit"} Tenant`;
    },
    result: {
            get: function() {
                return this.tenants.slice(this.skip, this.take + this.skip);
            }
        },
    total () {
        return this.tenants ? this.tenants.length : 0;
    }
  },
  methods: {
     pageChangeHandler: function(event) {
        this.skip = event.page.skip;
        this.take = event.page.take;
  },
    toArray: function (val) {
      if (Array.isArray(val) || val == undefined) return val;
      else return val.split(",");
    },
    async getIdentityPools() {
      try {
        const response = await axios.get(
          this.base_url + "IdentityPool/GetIdentityPools"
        );
        this.source = response.data.result;
      } catch (err) {
        console.log(err);
      }
    },

    async getLoginLayouts() {
      try {
        const response = await axios.get(
          this.base_url + "Tenant/GetLoginLayouts"
        );
        this.layouts = response.data.result;
      } catch (err) {
        console.log(err);
      }
    },
    async getTenants() {
      try {
        const client_id = oidcSettings.client_id;

        const response = await axios.get(this.base_url + "Tenant/GetTenants/"+this.selectedIdentity.id);
        this.tenants = response.data.result;
      } catch (err) {
        console.log(err);
      }
    },
    edit(dataItem) {
      this.tenantInEdit = this.cloneProduct(dataItem);
    },
    async remove(dataItem) {
      try {
        const client_id = oidcSettings.client_id;

        const response = await axios.delete(
          this.base_url + "Tenant/DeleteTenant/"+dataItem.id+"/"+this.selectedIdentity.id);
        console.log(response.data.message);
        this.tenants = this.tenants.filter((p) => p.id !== dataItem.id);
      } catch (err) {
        console.log(err);
      }
    },
    async uploadLogo(dataItem) {
      const formData = new FormData();
      formData.append("file", dataItem.logo);
      return axios.post(this.base_url + "Tenant/UploadTenantLogoImage/"+dataItem.id+"/"+this.selectedIdentity.id, formData, {
        header: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    async uploadBackgroundImage(dataItem) {
      const formData = new FormData();
      
      formData.append("file", dataItem.backgroundImage);
      return axios.post(this.base_url + "Tenant/UploadTenantBackgroundImage/"+dataItem.id+"/"+this.selectedIdentity.id, formData, {
        header: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    async registerTenant(dataItem) {
      const client_id = oidcSettings.client_id;

      let data = {
        name: dataItem.name,
        ID: dataItem.id,
        RedirectUri: dataItem.redirectUri,
        // ClientID: client_id,
        // IdentityPoolID: this.selectedIdentity.id,
        // IdentityPoolName: this.selectedIdentity.name,
        ImagePath: this.logoPath,
        BackgroundImagePath: this.bgPath,
        LoginLayout: dataItem.loginLayout,
        IsActive: dataItem.isActive,
        IsExternalRegAllowed: dataItem.isExternalRegAllowed,
      };
      const response = await axios
        .post(this.base_url + "Tenant/AddTenant/"+this.selectedIdentity.id, data)
        .then((response) => {
          var newObject = response.data.result;
          this.tenants.push(newObject);
        });
      this.dataItem = {};
    },
    async addTenant(dataItem) {
      this.bgPath = null;
      this.logoPath = null;
      if (dataItem.backgroundImage != null) {
        var result1 = await this.uploadBackgroundImage(dataItem);
        this.bgPath = result1.data.result;
      }
      if (dataItem.logo != null) {
        var result2 = await this.uploadLogo(dataItem);
        this.logoPath = result2.data.result;
      }
      var result3 = this.registerTenant(dataItem);
    },
    async editTenant(dataItem) {
      this.bgPath = dataItem.backgroundImagePath;
      this.logoPath = dataItem.imagePath;
      if (dataItem.backgroundImage != null) {
        var result1 = await this.uploadBackgroundImage(dataItem);
        this.bgPath = result1.data.result;
        dataItem.backgroundImage = null;
      }
      if (dataItem.logo != null) {
        var result2 = await this.uploadLogo(dataItem);
        this.logoPath = result2.data.result;
        dataItem.logo = null;
      }
      var result3 = await this.updateTenant(dataItem);
    },
    async updateTenant(dataItem) {
      let data = {
        name: dataItem.name,
        ID: dataItem.id,
        //RedirectUri:dataItem.redirectUri,
        //ClientID:client_id,
        // IdentityPoolID: this.selectedIdentity.id,
        // IdentityPoolName: this.selectedIdentity.name,
        ImagePath: this.logoPath,
        BackgroundImagePath: this.bgPath,
        LoginLayout: dataItem.loginLayout,
        IsActive: dataItem.isActive,
        IsExternalRegAllowed: dataItem.isExternalRegAllowed,
      };
      try {
        const response = await axios.put(
          this.base_url + "Tenant/UpdateTenant/"+this.selectedIdentity.id,
          data,
        );
        this.responseMsg = response.data.message;
        console.log(this.responseMsg);
        this.showMsg = true;
        const index = this.tenants.findIndex((p) => p.id === dataItem.id);
        this.tenants.splice(index, 1, response.data.result);
        this.dataItem = {};
      } catch (err) {
        console.log("Ooops!" + err);
      }
    },
    save() {
      const dataItem = this.tenantInEdit;
      const tenants = this.tenants.slice();
      const isNewTenant = this.tenants.find(
        (tenant) => tenant.id == dataItem.id
      );
      if (!isNewTenant) {
        this.addTenant(dataItem);
      } else {
        this.editTenant(dataItem);
      }
      this.tenantInEdit = undefined;
    },
    cancel() {
      this.tenantInEdit = undefined;
    },
    insert() {
      this.tenantInEdit = {};
    },
    cloneProduct(product) {
      return Object.assign({}, product);
    },
  },
};
</script>
<style >
.error {
  color: brown;
  margin: auto;
  text-align: left;
  padding: 5px;
}
.needs-validation {
  background: white;
}
</style>